import { useAppDrawerModules } from "$root/components/AppDrawer/Modules";
import { Redirect, useLocation } from "react-router";

export function IndexRedirect(): React.JSX.Element {
	const currentSidebarEntries = useAppDrawerModules();
	const firstAvailableRoute = currentSidebarEntries.top.filter((x) => x.enabled).find((route) => "href" in route);
	const carryHash = useLocation().hash;
	const carrySearchParams = useLocation().search;
	const redirectTo =
		firstAvailableRoute &&
		(() => {
			const url = new URL(
				`${window.location.origin}${firstAvailableRoute.href.startsWith("/") ? "" : "/"}${firstAvailableRoute.href}`,
			);
			const toAppend = new URLSearchParams(carrySearchParams);
			for (const [key, value] of toAppend.entries()) {
				url.searchParams.append(key, value);
			}
			return `${url.pathname}${url.search}${carryHash}`;
		})();

	return <>{redirectTo ? <Redirect to={redirectTo} /> : "No default service available"}</>;
}

export default IndexRedirect;
